import React from 'react';
import { connect } from 'react-redux';

import './styles.scss'
import DoubtsList from './doubtsList';
import Conversation from './conversation';
import { askADoubtSocketEndpoint, getSoketEndPoint } from '../../store/apiConstants';
import SocketService from './socketService';
import Authentication from '../session';
import Navbar from './../navbar';
import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
const TEACHER_ID = localStorage.getItem('discussion_uId');

const items = [
    { label: 'Academics' },
    { label: 'Ask a doubt ?', className: 'ma-active-item' },
    // { label: 'Role Creation', className: 'ma-active-item' }
];

const home = { icon: 'pi pi-home' }

class AskADoubt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0,
            selectedDoubt: null,
            currentSocketMessage: null,
            eventUID: 1,
        };
        this.socketService = new SocketService(getSoketEndPoint(), this.onConnectionOpen, this.onMessageRecieve);
    }

    componentWillUnmount() {
        this.socketService.closeConnection();
    }

    onConnectionOpen = (data) => {
        this.connectToOnline();
    };

    connectToOnline = async () => {
        if (this.props.discussionUser) {
            let payload = {
                action: "online",
                data: {
                    user: this.props.discussionUser ? this.props.discussionUser._id : null,
                    isOnline: true
                },
            };
            await this.socketService.socketSend(payload)
        }
    }

    onMessageRecieve = (data) => {
        let response = JSON.parse(data.data);
        //  console.log('onMessageRecieve', response)
        let eventUID = this.state.eventUID + 1;
        this.setState({
            currentSocketMessage: { ...response, eventUID },
            eventUID
        });
    }

    onTabChange = (newValue) => {
        this.setState({
            currentTab: newValue
        });
    }

    onDoubtRespond = (tab) => {
        setTimeout(() => {
            this.setState({
                currentTab: tab
            });
        }, 2000);
    }

    // onDoubtClosed = () => {
    //     setTimeout(() => {
    //         this.setState({
    //             currentTab: 1
    //         });
    //     }, 2000);
    // }


    onDoubtSelect = (doubt) => {
        this.setState({
            selectedDoubt: doubt
        });
    }

    connectToOnline2 = async (user) => {
        let payload = {
            action: "online",
            data: {
                user,
                isOnline: true
            },
        };
        await this.socketService.socketSend(payload)
    }

    componentWillReceiveProps(newProps) {
        if (this.props.discussionUser != newProps.discussionUser) {
            this.connectToOnline2(newProps.discussionUser._id)
        }
    }
    rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <h2 className='ma-tab-title'>Ask a Doubt ?</h2>
            </React.Fragment>
        )
    }

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <BreadCrumb model={items} home={home} />
            </React.Fragment>
        )
    }

    render() {

        return (
            <>
                <Navbar >
                    <div className="p-grid ma-toolbar">
                        <div className="p-col-12 p-md-1 ma-no-p">
                        </div>
                        <div className="p-col-12 p-md-11 ma-no-pm">
                            <Toolbar className="ma-toolbard" left={this.leftToolbarTemplate} right={this.rightToolbarTemplate}></Toolbar>
                        </div>
                    </div>
                    <div className="ask-a-doubt ma-main">
                        <div className="p-grid ">
                            <div className="p-col-12 p-md-6 p-lg-4 p-xl-4">
                                <div className="p-grid doubts-tabs">
                                    <div className={`p-col-4 p-xs-4 doubts-tab-w ${this.state.currentTab == 0 ? 'tab-active' : ''}`}>
                                        <p className={`ma-pointer tab-p  ${this.state.currentTab == 0 ? 'tab-active-p' : ''}`} onClick={() => { this.onTabChange(0) }}>New Doubts</p>
                                    </div>
                                    <div className={`p-col-4 p-xs-4 doubts-tab-w ${this.state.currentTab == 1 ? 'tab-active' : ''}`}>
                                        <p className={`ma-pointer tab-p ${this.state.currentTab == 1 ? 'tab-active-p' : ''}`} onClick={() => { this.onTabChange(1) }}>Attempted Doubts</p>
                                    </div>
                                    <div className={`p-col-4 p-xs-4 doubts-tab-w ${this.state.currentTab == 2 ? 'tab-active' : ''}`}>
                                        <p className={`ma-pointer tab-p ${this.state.currentTab == 2 ? 'tab-active-p' : ''}`} onClick={() => { this.onTabChange(2) }}>Closed Doubts</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="p-grid ">
                            <div className={`p-col-4 p-xs-4 ma-no-pm`}>
                                <DoubtsList currentSocketMessage={this.state.currentSocketMessage}
                                    socketSend={this.socketService.socketSend}
                                    currentTab={this.state.currentTab}
                                    selectedDoubt={this.state.selectedDoubt}
                                    onDoubtSelect={this.onDoubtSelect} />
                            </div>
                            <div className={`p-col-8 p-xs-8 ma-no-pm`}>
                                <Conversation currentSocketMessage={this.state.currentSocketMessage}
                                    socketSend={this.socketService.socketSend}
                                    currentTab={this.state.currentTab}
                                    selectedDoubt={this.state.selectedDoubt}
                                    onDoubtRespond={this.onDoubtRespond} />
                            </div>
                        </div>
                    </div>
                </Navbar>
            </>
        );
    }
}

const mapStatesToProps = (state) => ({
    discussionUser: state.currentUserPerms && state.currentUserPerms.discussionUser && state.currentUserPerms.discussionUser,
});

export default connect(mapStatesToProps, {})(Authentication(AskADoubt));
